module.exports = __webpack_public_path__ + "static/media/School_closing_timeline.717a984b.svg";